import { AbstractControl, ValidationErrors } from '@angular/forms';

export function outputsValidator(
  formControl: AbstractControl
): ValidationErrors | null {
  if (!formControl.value) {
    return null;
  }

  const value = formControl.value as {
    outputs: { value: number; isRemainder: boolean }[];
    distributionType: string;
  };

  if (
    !value ||
    !value.outputs ||
    !value.distributionType ||
    value.outputs.every((output) => !output.value)
  ) {
    return null;
  }

  if (value.distributionType === 'Percent') {
    const sum = value.outputs.reduce(
      (acc, output) => acc + (output.value ?? 0),
      0
    );

    if (sum > 100) {
      return {
        invalidOutputs: 'splitter.form-errors.sum-exceeds-100',
      };
    }
    if (!value.outputs.some((output) => output.isRemainder) && sum < 100) {
      return {
        invalidOutputs: 'splitter.form-errors.sum-less-than-100',
      };
    }
  } else {
    const hasActiveRemainder = value.outputs.some(
      (output) => output.isRemainder
    );
    if (!hasActiveRemainder) {
      return {
        invalidOutputs: 'splitter.form-errors.define-remainder',
      };
    }
  }
  return null;
}
